export const planUsageKeys = {
  all: ['plan-usage'] as const,
  detail: () => [...planUsageKeys.all] as const,
};
